import { ArrowIcon } from '@modusign/design-system';
import cx from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { validateEmail, validatePreviousPassword } from '@app/libs/validation';
import { activateInactiveAccount } from '@app/store/account/actions';
import { modalClose } from '@app/store/modal/actions';

/** @deprecated */
const AccountInactiveActivationModal = () => {
  const [email, setEmail] = useState('');
  const [emailMessage, setEmailMessage] = useState('');
  const [password, setPassword] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');
  const [emailCheck, setEmailCheck] = useState(false);
  const [passwordCheck, setPasswordCheck] = useState(false);

  const dispatch = useDispatch();

  const handleActivate = () => {
    if (email && password && !emailMessage && !passwordMessage) {
      dispatch(activateInactiveAccount({ email, password }));
      dispatch(modalClose());
    }
  };

  const handleCloseModal = () => {
    dispatch(modalClose());
  };

  const handleOnEmailBlur = () => {
    setEmailCheck(true);
    const { message } = validateEmail(email);
    setEmailMessage(message);
  };

  const handleOnEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    setEmail(value);
    if (emailCheck) {
      const { message } = validateEmail(value);
      setEmailMessage(message);
    }
  };

  const handleOnPasswordBlur = () => {
    setPasswordCheck(true);
    const { message } = validatePreviousPassword(password);
    setPasswordMessage(message);
  };

  const handleOnPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    setPassword(value);
    if (passwordCheck) {
      const { message } = validatePreviousPassword(value);
      setPasswordMessage(message);
    }
  };

  return (
    <div className="Container Container--max-xxs">
      <div className="Card Card--pop align-center box-6x">
        <h4 className="space-3x">
          <strong>휴면 계정 해제</strong>
        </h4>
        <p className="space-6x">
          안전한 잠금 해제를 위해
          <br />한 번 더 이메일과 비밀번호를 입력해 주세요.
        </p>
        <div className="space-6x">
          <div className={cx('InputSet', { 'InputSet--invalid': emailMessage })}>
            <input
              className="InputSet__text-input"
              name="email"
              placeholder="이메일"
              type="email"
              value={email}
              onBlur={handleOnEmailBlur}
              onChange={handleOnEmailChange}
            />
            <p className="InputSet__invalidity-message">{emailMessage}</p>
          </div>
          <div className={cx('InputSet', { 'InputSet--invalid': passwordMessage })}>
            <input
              className="InputSet__text-input"
              name="password"
              placeholder="비밀번호"
              type="password"
              value={password}
              onBlur={handleOnPasswordBlur}
              onChange={handleOnPasswordChange}
            />
            <p className="InputSet__invalidity-message">{passwordMessage}</p>
          </div>
        </div>
        <button className="Btn" name="close" type="button" onClick={handleCloseModal}>
          취소
        </button>
        <button className="Btn Btn--primary" name="activate" type="button" onClick={handleActivate}>
          해제 완료
          <ArrowIcon direction="right" ml="2px" />
        </button>
      </div>
    </div>
  );
};

export default AccountInactiveActivationModal;
